module.exports = __webpack_public_path__ + "media/images/official/top_mv1_sp-4062d3dc94e0ad856bcf3a938353743a.jpg";